import { PointTuple } from "leaflet";

export const getBoundsCenter = (bounds: PointTuple[]): PointTuple => {
  const lat = bounds.reduce((acc, [lat, _]) => acc + lat, 0) / bounds.length;
  const lon = bounds.reduce((acc, [_, lon]) => acc + lon, 0) / bounds.length;

  return [lat, lon];
};
